import React, { useRef } from "react";
import { UserOutlined, MailOutlined, PhoneOutlined, ShopOutlined } from "@ant-design/icons";
import "./crm.css";

// Horizontally-scrolling row of compact contact cards.
// Used in two places with the SAME card style:
//  - Office drawer: contacts of one office (no office header).
//  - Practice drawer: contacts across all offices — each card shows its office
//    name; when `onOpenOffice` is given the name links to that office's drawer.
export default function ContactCarousel({ contacts, onOpenOffice }) {
  const trackRef = useRef(null);
  if (!contacts || contacts.length === 0) return null;
  const many = contacts.length > 2;
  const scroll = (dir) => {
    const el = trackRef.current;
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: "smooth" });
  };

  const renderOffice = (c) => {
    if (!c.office_name) return null;
    if (onOpenOffice && c.office_id) {
      return (
        <button
          className="crm-cc-office crm-cc-office-link"
          onClick={() => onOpenOffice(c.office_id)}
          title={`Open ${c.office_name}`}
        >
          <ShopOutlined /><span className="crm-cc-txt">{c.office_name}</span>
        </button>
      );
    }
    return (
      <span className="crm-cc-office">
        <ShopOutlined /><span className="crm-cc-txt">{c.office_name}</span>
      </span>
    );
  };

  return (
    <div className="crm-contacts-carousel">
      {many ? (
        <button className="crm-cc-arrow" onClick={() => scroll(-1)} aria-label="Previous">‹</button>
      ) : null}
      <div className="crm-cc-track" ref={trackRef}>
        {contacts.map((c) => (
          <div className="crm-contact-card" key={c.office_id ? `${c.office_id}-${c.id}` : c.id}>
            {renderOffice(c)}
            <div className="crm-cc-body">
              <div className="crm-cc-id">
                <div className="crm-contact-avatar"><UserOutlined /></div>
                <div className="crm-cc-idtext">
                  <div className="crm-contact-name" title={c.name}>{c.name || "—"}</div>
                  {c.title ? <div className="crm-contact-title" title={c.title}>{c.title}</div> : null}
                </div>
              </div>
              <div className="crm-cc-meta">
                {c.email ? (
                  <span className="crm-contact-metaitem" title={c.email}>
                    <MailOutlined /><span className="crm-cc-txt">{c.email}</span>
                  </span>
                ) : null}
                {c.phone ? (
                  <span className="crm-contact-metaitem" title={c.phone}>
                    <PhoneOutlined /><span className="crm-cc-txt">{c.phone}</span>
                  </span>
                ) : null}
                {!c.email && !c.phone ? (
                  <span className="crm-contact-metaitem crm-muted">No contact details</span>
                ) : null}
              </div>
            </div>
          </div>
        ))}
      </div>
      {many ? (
        <button className="crm-cc-arrow" onClick={() => scroll(1)} aria-label="Next">›</button>
      ) : null}
    </div>
  );
}
